import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GetDisneyPlusDetails } from 'src/app/store/actions/smooth-access.actions';
import {
  ApplicationState,
  getDisneyPlusSelectedProductDetails,
  getProductDetailsTechnicalError,
} from 'src/app/store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { EnvironmentService } from '@proximus/ng-common';

@Injectable()
export class SmoothAccessTokenDisneyPlusGuard
  extends OnDestroyHookDirective
  implements CanActivate
{
  constructor(
    private environmentService: EnvironmentService,
    private store: Store<ApplicationState>,
  ) {
    super();
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return new Observable((observer) => {
      if (!this.environmentService.isSmoothAccess) {
        observer.next(false);
        observer.error();
      }

      const queryParamToken = route.queryParamMap.get('token');
      if (!queryParamToken) {
        //redirect
        window.location.assign(
          window.location.href.replace('/smoothAccess', '/myproximus'),
        );

        observer.next(false);
        observer.error();
      }

      this.store.dispatch(
        new GetDisneyPlusDetails({
          token: queryParamToken,
        }),
      );

      this.store
        .select(getDisneyPlusSelectedProductDetails)
        .subscribe((value) => {
          if (value && value.tvProductDetails) {
            observer.next(true);
            observer.complete();
          }
        });

      this.store.select(getProductDetailsTechnicalError).subscribe((value) => {
        if (value) {
          observer.next(false);
          observer.error();
          //redirect
          window.location.assign(
            window.location.href.replace('/smoothAccess', '/myproximus'),
          );
        }
      });
    });
  }
}
